import React, { useState } from "react";
import { db, storage } from "./firebase";
import {
  collection,
  addDoc,
  deleteDoc,
  doc,
  getDocs,
  setDoc,
} from "firebase/firestore";
import { ref, uploadBytes, getDownloadURL } from "firebase/storage";

function MuralUploader() {
  const [file, setFile] = useState(null);
  const [cols, setCols] = useState(4);
  const [rows, setRows] = useState(5);

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };

const handleUpload = async () => {
  if (!file) {
    alert("Please choose an image file first.");
    return;
  }

  try {
    // ❌ REMOVE THIS:
    // const existing = await getDocs(collection(db, "squares"));
    // for (let snap of existing.docs) {
    //   await deleteDoc(doc(db, "squares", snap.id));
    // }

    // optional: create a batch/mural id so you can know which squares belong together
    const muralId = crypto.randomUUID ? crypto.randomUUID() : Date.now().toString();

    await setDoc(doc(db, "gameSettings", "activeMural"), {
  muralId
});


    // ✅ Step 2: Load image into canvas
    const img = new Image();
    img.src = URL.createObjectURL(file);
    await new Promise((resolve) => (img.onload = resolve));

    const targetWidth = 400;
    const targetHeight = 500;
    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");
    canvas.width = targetWidth;
    canvas.height = targetHeight;
    ctx.drawImage(img, 0, 0, targetWidth, targetHeight);

    // ✅ Step 3: Slice into tiles
    const tileWidth = targetWidth / cols;
    const tileHeight = targetHeight / rows;

    for (let row = 0; row < rows; row++) {
      for (let col = 0; col < cols; col++) {
        const tileCanvas = document.createElement("canvas");
        const tileCtx = tileCanvas.getContext("2d");
        tileCanvas.width = tileWidth;
        tileCanvas.height = tileHeight;
        tileCtx.drawImage(
          canvas,
          col * tileWidth,
          row * tileHeight,
          tileWidth,
          tileHeight,
          0,
          0,
          tileWidth,
          tileHeight
        );

        const blob = await new Promise((resolve) =>
          tileCanvas.toBlob(resolve, "image/png")
        );

        // you *can* keep this path if you don't care about old tile images in Storage
        // but it's a bit nicer to nest by muralId:
        const storageRef = ref(
          storage,
          `squares/${muralId}/tile_${row}_${col}.png`
        );

        await uploadBytes(storageRef, blob);
        const downloadURL = await getDownloadURL(storageRef);

        await addDoc(collection(db, "squares"), {
          muralId,          // NEW: groups all squares for this upload
          row,
          col,
          claimed: false,
          claimedBy: "",
          username: "",
          claimedAt: null,
          uploadedDrawingUrl: "",
          originalPieceUrl: downloadURL,
        });
      }
    }

    // ✅ Step 4: Save grid settings (still just for the “current” mural)
    await setDoc(doc(db, "gameSettings", "grid"), { rows, cols });

    alert("✅ Mural uploaded, sliced, and grid saved!");
  } catch (err) {
    console.error("Upload failed:", err);
    alert("❌ Upload failed, check console for details.");
  }
};


  return (
    <div style={{ marginBottom: "20px" }}>
      <h3>Upload New Mural</h3>
      <input type="file" onChange={handleFileChange} />
      <div>
        <label>
          Columns:
          <input
            type="number"
            value={cols}
            onChange={(e) => setCols(parseInt(e.target.value))}
            style={{ width: "50px", marginLeft: "5px" }}
          />
        </label>
        <label style={{ marginLeft: "10px" }}>
          Rows:
          <input
            type="number"
            value={rows}
            onChange={(e) => setRows(parseInt(e.target.value))}
            style={{ width: "50px", marginLeft: "5px" }}
          />
        </label>
      </div>
      <button onClick={handleUpload} style={{ marginTop: "10px" }}>
        Upload & Slice Mural
      </button>
    </div>
  );
}

export default MuralUploader;
